/**
 * Factory method for creating a Tuple instance.
 * @param args
 */
export const tuple = (...args) => args;
//# sourceMappingURL=tuple.js.map